module.exports = __webpack_public_path__ + "static/media/gallery1.e48a6d77.webp";